import { useEffect } from 'react'
import { useLanguages } from '@/hooks/useLanguages'

/**
 * Makes the language a page belongs to the active one, so the nav's language
 * dropdown shows where the learner actually is — however they got here (a
 * dashboard row, a breadcrumb, a pasted URL), not just via the dropdown.
 *
 * Pass `undefined` while the language is still loading (e.g. a reading page
 * learns it from the fetched reading).
 */
export function useCurrentLanguage(languageId: number | null | undefined) {
  const { selectedLanguageId, setSelectedLanguageId } = useLanguages()

  useEffect(() => {
    if (languageId != null && languageId !== selectedLanguageId) setSelectedLanguageId(languageId)
  }, [languageId, selectedLanguageId, setSelectedLanguageId])
}
